import { withInstall } from '../../utils/install';
import InputNumber from './index.vue';

export const IvueInputNumber = withInstall(InputNumber);
export default IvueInputNumber;

export * from './index.vue';
